import React from "react";
import { useArtistStory } from "@/api/hooks/useArtistStory";
import { useArtistDisplayName } from "@/api/hooks/useArtistDisplayName";
import { ArtistStoryRichText } from "@/components/profile/ArtistStoryRichText";

const ArtistFreeStory = () => {
  const { storyHtml, hasStory } = useArtistStory();
  const displayName = useArtistDisplayName();

  return (
    <div className=" p-4 md:p-[1rem] flex flex-col justify-center items-center mt-8 md:mt-28 w-screen">
      <p className="text-[28px] md:text-[42px] font-bold bg-gradient-to-r from-[#F16B2E] via-[#EC2179] to-[#EC2179] text-transparent bg-clip-text mb-4">
        MY STORY
      </p>
      <ArtistStoryRichText
        storyHtml={storyHtml}
        hasStory={hasStory}
        variant="free"
        maskExactName={displayName}
      />
    </div>
  );
};

export default ArtistFreeStory;
